import React, {useEffect, useState} from 'react';
import { BASE_API } from '../../api/Globals';
import { useParams } from "react-router";
import { helpHttp } from '../../helpers/helpHttp';
import MessageDetail from '../../components/sturtural/MessageDetail';
import Loader from '../../components/sturtural/Loader';
import "../access/css.css";

const VerificationCedula = () => {
    const [db, setDb] = useState(null); 
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    
    let {q} = useParams();

    let url = `${BASE_API}demand/cedulas/${q}`;

    useEffect(() => {
        setLoading(true);
        if(q) { 
            helpHttp().get(url).then(res => {
                if(!res.err) {
                   
                    if(res.response === "on") {
                        setDb(res.cedula);
                        setError(null);
                    } else {
                        setDb(null);
                        setError(res);
                    }
                } else {
                    setDb(null);
                    setError(res);
                }
                setLoading(false);
            });
        } else {
            setDb(null);
        }

    }, [url]);

    const iconstyle = {
        'width': "48px",
        'height': "48px",
        'borderRadius': "10px"
    };

    const dropdownNivel = [
        {name: 'Técnico', code: "T"},
        {name: 'Técnico Superior Universitario', code: "T"},
        {name: 'Licenciatura', code: "L"},
        {name: 'Maestria', code: "M"},
        {name: 'Doctorado', code: "D"}
    ];

    return (
        <>
            <div className="col-12 text-center">
                <img className="logo" src="assets/layout/images/Logo SEC HÍBRIDO 2022_Mesa de trabajo 1.svg" alt="Logo"/>
                <h4 className="m-0"><span className="col-12">Secretaría de Educación y Cultura</span></h4>
                <h6 className="m-0"><span className="col-12">Coordinación General de Registro, Certificación
                y Servicios a Profesionistas</span></h6>
                <center><hr style={{"height": "3px","max-width":"80em"}} /></center>
                <h5><span>VERIFICACIÓN DE DATOS DE SU CÉDULA PROFESIONAL ELECTRÓNICA CON QR</span></h5>
            </div>
            
            {(loading &&  <Loader /> )}
            {(db ?  
                <div className='surface-ground px-0 flex align-items-center justify-content-center grid m-0'>
                    
                    <div className="col-12 lg:col-5 p-0">
                        <div className="shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex">
                            <div className="p-4">
                                <div className="flex align-items-center">
                                    <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={iconstyle}><i className={`pi pi-check-circle text-xl text-gray-600`}></i></span>
                                    <span className="text-900 font-medium text-2xl">HOLOGRAMA: {db.no_ced_pro}</span>
                                </div>
                                <div className="text-900 my-3 text-2xl font-medium" style={{"textAlign":"center"}}>{db.nombre} {db.apellido1} {db.apellido2}</div>
                                <hr style={{"height": "3px"}} />
                            </div>
                            <div className="col-12">
                                <ul className="list-none p-10 m-0 flex-grow-1">
                                    <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>{db.institucion_educativa}</span></li>
                                    <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>{db.programa}</span></li>
                                    <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i> <span>{db.nivel}</span> </li>
                                    <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>CURP: {db.curp}</span></li>
                                    <li className="flex align-items-center mb-3"><i className="pi pi-check-circle text-green-500 mr-2"></i><span>{db.fecha_registro}</span></li>
                                    <li className="flex col-11 word-break">
                                        <div className="grid">
                                            <i className="pi pi-check-circle text-green-500 mr-2"></i>
                                            <span>FEA: </span>
                                            <span className="font-11 pl-4">{db.fea}</span>
                                        </div>
                                    </li>
                                    <li className="flex col-11 word-break">
                                        <div className="grid">
                                            <i className="pi pi-check-circle text-green-500 mr-2"></i>
                                            <span>SELLO: </span> 
                                            <span className="font-11 pl-4">{db.sello}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <MessageDetail color="error" mensaje="NO SE ENCONTRÓ INFORMACIÓN" />
            )}

        </>
    );
}

export default VerificationCedula;